import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Petitum } from '../../../models/petitum';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { SezioneEconomicaDataInteressiEditComponent } from './sezione-economica-data-interessi-edit.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-data-interessi-edit]',
  templateUrl: 'sezione-economica-mod-data-interessi-edit.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class SezioneEconomicaModDataInteressiEditComponent {
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formDataInteressi') formDataInteressi: SezioneEconomicaDataInteressiEditComponent;

  inizializza(sezione: SezioneEconomica, petitum: Petitum, urlUpdateDataInizioCalcolo: string, tipoData: string) {
    this.formDataInteressi.inizializza(sezione, petitum, urlUpdateDataInizioCalcolo, tipoData);
    openModal('modaleDataInteressiEdit');
  }

  createForm() {
    this.formDataInteressi.createForm();
  }

  manageModal(sezioneEconomica: SezioneEconomica) {
      closeModal('modaleDataInteressiEdit');
      this.onReturn.emit(sezioneEconomica);
  }
}
